import { Question } from './question.js';
import { starEmptySvg, starFilledSvg } from '../icons/icons.js';

export class RatingScaleQuestion extends Question {

    renderContent() {
        let answer = [''];
        let range = Math.abs(this.question.ratingMax.number - this.question.ratingMini.number) + 1;
        let temArray = Array.from({ length: range }, (_, i) => i);

        if (range < 11) {
            let block = document.createElement('div');
            block.style.display = 'flex';
            block.style.justifyContent = 'center';
            block.style.alignItems = 'center';
            block.style.width = '100%';
            block.style.flexDirection = 'column';

            let ratingBlock = document.createElement('div');
            ratingBlock.style.width = '100%';
            ratingBlock.classList.add('ph-rating--small');
            block.appendChild(ratingBlock);

            let ratingElement = document.createElement('div');
            ratingElement.classList.add('ph-rating__element');
            ratingElement.style.width = '100%';
            ratingElement.style.gap = '1px';
            ratingElement.setAttribute('role', 'group');
            ratingElement.setAttribute('aria-labelledby', 'ph-title-' + this.question.id);
            ratingBlock.appendChild(ratingElement);

            let selectedIndex = -1;
            let hoveredIndex = null;

            if (this.question.ratingSymbol === 'Stars') {
                // Determine star size based on number of rating options
                let starSize = '38px';
                if (range <= 5) {
                    starSize = '38px';
                } else if (range <= 8) {
                    starSize = '32px';
                } else {
                    starSize = '24px';
                }
                ratingElement.style.setProperty('--ph-star-size', starSize);

                let starButtons = [];

                const updateStarButtonsStyles = () => {
                    starButtons.forEach((btn, idx) => {
                        let isSelected = (selectedIndex !== -1 && idx <= selectedIndex);
                        let isHovered = (hoveredIndex !== null && hoveredIndex !== -1 && idx <= hoveredIndex);

                        let bgColor = 'transparent';
                        let starColor = '#F0F0F1';
                        let numColor = this.style.elementColor;
                        let ariaPressed = 'false';

                        if (isSelected || isHovered) {
                            starColor = this.style.elementColor;
                            ariaPressed = 'true';
                        }

                        btn.style.backgroundColor = bgColor;

                        let iconContainer = btn.querySelector('.ph-rating__star-icon');
                        if (iconContainer) {
                            iconContainer.innerHTML = starFilledSvg(starColor, starSize, starSize);
                        }

                        let numContainer = btn.querySelector('.ph-rating__star-number');
                        if (numContainer) {
                            numContainer.style.color = numColor;
                        }

                        btn.setAttribute('aria-pressed', ariaPressed);
                    });
                };

                temArray.forEach((index) => {
                    let ratingButton = document.createElement('button');
                    ratingButton.classList.add('ph-rating__btn--star');
                    ratingButton.id = 'star' + this.question.id + index;
                    ratingButton.value = Number(index);
                    ratingButton.setAttribute('aria-label', `${index + 1} of ${range} stars`);
                    ratingButton.setAttribute('aria-pressed', 'false');

                    let starIconContainer = document.createElement('div');
                    starIconContainer.classList.add('ph-rating__star-icon');
                    ratingButton.appendChild(starIconContainer);

                    let ratingNumberContainer = document.createElement('div');
                    ratingNumberContainer.classList.add('ph-rating__star-number');
                    ratingNumberContainer.textContent = Number(this.question.ratingMini.number) + index;
                    ratingButton.appendChild(ratingNumberContainer);

                    ratingElement.appendChild(ratingButton);
                    starButtons.push(ratingButton);

                    ratingButton.onclick = () => {
                        if (selectedIndex === index) {
                            selectedIndex = -1;
                            answer[0] = '';
                        } else {
                            selectedIndex = index;
                            answer[0] = Number(ratingButton.value) + 1;
                        }
                        updateStarButtonsStyles();
                        setTimeout(() => {
                            this.ctx.goNext(this.question, answer[0]);
                        }, 250);
                    };

                    ratingButton.onmouseenter = () => {
                        hoveredIndex = index;
                        updateStarButtonsStyles();
                    };

                    ratingButton.onmouseleave = () => {
                        hoveredIndex = null;
                        updateStarButtonsStyles();
                    };
                });

                // Initialize Star styles
                updateStarButtonsStyles();
            }

            if (this.question.ratingSymbol === 'Numbers') {
                let numberButtons = [];

                const updateNumberButtonsStyles = () => {
                    let activeIndex = (hoveredIndex !== null && hoveredIndex !== -1) ? hoveredIndex : selectedIndex;
                    numberButtons.forEach((btn, idx) => {
                        let isHighlighted = (activeIndex !== null && activeIndex !== -1 && idx === activeIndex);
                        if (isHighlighted) {
                            btn.style.backgroundColor = this.style.elementColor;
                            btn.style.color = this.style.buttonTextColor || '#FFFFFF';
                            btn.setAttribute('aria-pressed', 'true');
                        } else {
                            btn.style.backgroundColor = '#F0F0F1';
                            btn.style.color = this.style.elementColor;
                            btn.setAttribute('aria-pressed', 'false');
                        }
                    });
                };

                temArray.forEach((index) => {
                    let ratingButton = document.createElement('button');
                    ratingButton.classList.add('ph-rating__btn--number');
                    ratingButton.id = 'number' + this.question.id + index;
                    ratingButton.value = Number(index);
                    ratingButton.textContent = Number(this.question.ratingMini.number) + index;
                    ratingButton.setAttribute('aria-label', `Rate ${Number(this.question.ratingMini.number) + index}`);
                    ratingButton.setAttribute('aria-pressed', 'false');

                    let borderRadii = '2px';
                    if (temArray.length === 1) {
                        borderRadii = '4px';
                    } else if (index === 0) {
                        borderRadii = '4px 2px 2px 4px';
                    } else if (index === temArray.length - 1) {
                        borderRadii = '2px 4px 4px 2px';
                    }
                    ratingButton.style.borderRadius = borderRadii;

                    ratingElement.appendChild(ratingButton);
                    numberButtons.push(ratingButton);

                    ratingButton.onclick = () => {
                        if (selectedIndex === index) {
                            selectedIndex = -1;
                            answer[0] = '';
                        } else {
                            selectedIndex = index;
                            answer[0] = Number(ratingButton.value) + 1;
                        }
                        updateNumberButtonsStyles();
                        setTimeout(() => {
                            this.ctx.goNext(this.question, answer[0]);
                        }, 250);
                    };

                    ratingButton.onmouseenter = () => {
                        hoveredIndex = index;
                        updateNumberButtonsStyles();
                    };

                    ratingButton.onmouseleave = () => {
                        hoveredIndex = null;
                        updateNumberButtonsStyles();
                    };
                });

                // Initialize Number styles
                updateNumberButtonsStyles();
            }

            let ratingContextBlock = document.createElement('div');
            ratingContextBlock.classList.add('ph-rating__context');

            let lowRatingTextElement = document.createElement('div');
            lowRatingTextElement.classList.add('ph-rating__label');
            lowRatingTextElement.textContent = this.question.ratingMini.text;
            lowRatingTextElement.style.textAlign = 'left';
            ratingContextBlock.appendChild(lowRatingTextElement);

            let longRatingTextElement = document.createElement('div');
            longRatingTextElement.classList.add('ph-rating__label');
            longRatingTextElement.textContent = this.question.ratingMax.text;
            longRatingTextElement.style.textAlign = 'right';
            ratingContextBlock.appendChild(longRatingTextElement);

            ratingBlock.appendChild(ratingContextBlock);
            return block;
        }
    }
}
